module.exports = __webpack_public_path__ + "img/szotyi.c4deac9b.png";